import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import FormModal from '../../FormModal.jsx';
import GroupForm from './GroupForm.jsx';
import { selectCurrentOrganizationId } from '../../../modules/auth.js';
import { retrieveProject } from '../../../modules/projects.js';
import {
  createGroup,
  selectFlattenedOrgGroups,
} from '../../../modules/orgGroups.js';

const mapStateToProps = (state) => ({
  organizationId: selectCurrentOrganizationId(state),
  flattenedGroups: selectFlattenedOrgGroups(state),
});

const mapDispatchToProps = { createGroup, retrieveProject };

const groupPropTypes = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  parentId: PropTypes.number,
});

function GroupFormModal(props) {
  const {
    onHide,
    show,
    groups,
    flattenedGroups,
    organizationId,
    createGroup,
    onSubmitSuccess,
  } = props;

  const [selectedParentGroupId, setSelectedParentGroupId] = useState(null);
  const updateParentGroupId = (id) => setSelectedParentGroupId(id);

  const createResource = (values) => {
    const group = {
      name: values.name,
      parentId: selectedParentGroupId,
    };

    return createGroup(organizationId, group);
  };

  const validate = useCallback((values) => {
    const errors = {};
    if (!values.name) {
      errors.name = 'Name is required';
    }

    return errors;
  }, []);

  const onSubmitSuccessAction = (result) => {
    onSubmitSuccess && onSubmitSuccess(result);
  };

  useEffect(() => {
    updateParentGroupId(null);
  }, [show]);

  return (
    <FormModal
      createResource={createResource}
      onHide={onHide}
      onSubmitSuccess={(result, entities) =>
        onSubmitSuccessAction(result, entities)
      }
      resourceName="Group, Team or Department"
      show={show}
      updateResource={() => {}}
      validate={validate}
      getEntities
    >
      <GroupForm
        groups={groups}
        flattenedGroups={flattenedGroups}
        selectedParentGroupId={selectedParentGroupId}
        onSelectParentGroup={updateParentGroupId}
      />
    </FormModal>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(GroupFormModal);
